import React, { useEffect, useRef, useState } from 'react'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useStoreValues } from '../../Context/storeProvider';
import { combineAllRoutes, filterRouteData, getLocalStorage, setLocalStorage } from '../../Functions/Utils';
import { routeList } from '../../globalData/constant';
import Home from '../../Screens/Home/Home';
import Login from '../../Screens/Login/Login';
import { ManageApis } from '../../AppServices/ManageApi';
import { now } from 'moment';
import Landingpage from '../../Screens/LandingPage/Landingpage';
import Dashboard from '../../Screens/Dashboard/Dashboard';
import SignatureCrop from '../../Screens/SignatureVerificationScreen/SignatureCrop';
import FaceMatching from '../../Screens/FaceMatching/FaceMatching';
import Register from '../../Screens/Register/Register';
import Cheque_comparison from '../PocLayout/Cheque_comparisonNPCI';
import DocumentComparison from '../../Screens/DocumentComparison/DocumentComparison';
import AiChatbot from '../../Screens/AiChatbot/AiChatbot';


function RouterComponent() {
  const { user_Roll, menuList, setMenuList } = useStoreValues();
  const [intervalId, setIntervalId] = useState(null);
  const isMounted = useRef(true); // Create a ref to track component mount/unmount state

  useEffect(() => {
    // Component unmounted, set isMounted to false
    return () => {
      isMounted.current = false;
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    // //console.log("-------------->", menuList)
  }, [menuList])


  useEffect(() => {
    if (user_Roll === "Client") {
      // ""
      // Set a new interval when user_Roll is "Client"
      const newIntervalId = setInterval(() => {
        UpdateListMenuApiCall();
      }, 2000);
      setIntervalId(newIntervalId);
    } else if (!isMounted.current) {
      // Clear the interval only if component is mounted and user_Roll is not "Client"
      clearInterval(intervalId);
    }
  }, [user_Roll]);

  async function UpdateListMenuApiCall() {


    try {
      const param = `?UserID=${getLocalStorage("clientId")}`
      let result = await ManageApis(
        "get",
        global.ListingMenusByUser, param,
      );
      // //console.log(result.response_data);

      if (result?.message === "Success") {
        // ""
        let formatingMenuList = [
          { menuName: "landing" },
          {
            menuName: "hitdashboard"
          },
          {
            menuName: "hitoverview"
          },
          { menuName: "api-logs" },
          { menuName: "service-logs" }
        ]

        // //console.log(result?.response_data)
        formatingMenuList = formatingMenuList.concat(result?.response_data.map((itm) => ({
          ...itm, id: itm.menuId
        })))
        // ""
        //console.log(formatingMenuList)
        setLocalStorage({
          menuList: JSON.stringify(formatingMenuList.length > 0 ? formatingMenuList : []),

        });
        // setMenuList(formatingMenuList.length > 0 ? formatingMenuList : ["DashBoard"])

      } else {
        // //console.log(result)
      }
    } catch (err) {
      // //console.log(err)
    }
  }


  const getRoutes = (userRoll)=>{
    switch (userRoll) {
  case "Admin":
      return (
        ["/admin/user_list", "/admin/user-details", "/admin/menu_list", "/admin/acount_list",
        // "/admin/hit-dashboard",
        // "/admin/hit-client",
        "/admin/hit-services",
        //  "/admin/hit-key", 
        "/admin/hit-deploymentserver",
        "/admin/hit-hitoverview", "/admin/clientlist", "/admin/clientdetails",
        "/admin/client_admin_list",
        "/api-logs",
      "/service-logs"].map(
          (itm, index) => (
            <Route
              key={index}
              exact
              path={itm}
              element={
                <Home
                  sideBarComponent={{
                    "Admin Dashboard": [
                      {
                        icon: "fas fa-file-invoice",
                        name: "admin user_list",
                        path: "/admin/user_list",
                        section: "Admin Dashboard",
                        sideMenuName: "User List",
                      },
                      {
                        icon: "fas fa-file-invoice",
                        name: "admin Menu_list",
                        path: "/admin/menu_list",
                        section: "Admin Dashboard",
                        sideMenuName: "Menu List",
                      },
                      // {
                      //   icon: "fas fa-file-invoice",
                      //   name: "admin Account_list",
                      //   path: "/admin/acount_list",
                      //   section: "Admin Dashboard",
                      //   sideMenuName: "Account ",
                      // },
                      {
                        icon: "fas fa-file-invoice",
                        name: "admin client_admin_list",
                        path: "/admin/client_admin_list",
                        section: "Admin Dashboard",
                        sideMenuName: "Client Admin List",
                      },
                    ],
                    "API Hit": [
                      // {
                      //   icon: "fas fa-file-invoice",
                      //   name: "admin hit-dashboard",
                      //   path: "/admin/hit-dashboard",
                      //   section: "Hit Dashboard",
                      //   sideMenuName: "Dashboard ",
                      // },
                      // {
                      //   icon: "fas fa-file-invoice",
                      //   name: "admin hit-client",
                      //   path: "/admin/hit-client",
                      //   section: "Hit Dashboard",
                      //   sideMenuName: "Client",
                      // },
                      // {
                      //   icon: "fas fa-file-invoice",
                      //   name: "admin hit-services",
                      //   path: "/admin/hit-services",
                      //   section: "Hit Dashboard",
                      //   sideMenuName: "Services",
                      // },
                      // {
                      //   icon: "fas fa-file-invoice",
                      //   name: "admin hit-key",
                      //   path: "/admin/hit-key",
                      //   section: "Hit Dashboard",
                      //   sideMenuName: "Services Key",
                      // },
                      // {
                      //   icon: "fas fa-file-invoice",
                      //   name: "admin hit-deploymentserver",
                      //   path: "/admin/hit-deploymentserver",
                      //   section: "Hit Dashboard",
                      //   sideMenuName: "Deployment Server",
                      // },
                      {
                        icon: "fas fa-file-invoice",
                        name: "admin hit-hitoverview",
                        path: "/admin/hit-hitoverview",
                        section: "Hit Dashboard",
                        sideMenuName: "Overview",
                      },
                    ],
                    // "Client": [
                    //   {
                    //     icon: "fas fa-file-invoice",
                    //     name: "admin newClient",
                    //     path: "/admin/clientlist",
                    //     section: "Additions",
                    //     sideMenuName: "Clients",

                    //   }
                    // ],
                    "API Logs": [
                      {
                        icon: "fas fa-file-invoice",
                        name: "admin api-logs",
                        path: "/api-logs",
                        section: "API Logs",
                        sideMenuName: "Dashboard",

                      },
                      {
                        icon: "fas fa-file-invoice",
                        name: "service-logs",
                        path: "/service-logs",
                        section: "API Logs",
                        sideMenuName: "Dashboard",
                      }
                    ]
                  }}
                  section={"Admin Dashboard"}

                />
              }
            />
          )
        )
      )
    
  case "AdminClient":
      return (
        ["/admin/user_list",
        "/admin/hit-hitoverview",
        // "/admin/hit-dashboard",
        // "/admin/hit-client",
        // "/admin/hit-services",
        //  "/admin/hit-key", 
        // "/admin/hit-deploymentserver",
         "/admin/clientlist",
          "/admin/clientdetails",
         "/admin/user-details",
          "/admin/clientdetails",
        "/api-logs",
        "/service-logs",
      ].map(
          (itm, index) => (
            <Route
              key={index}
              exact
              path={itm}
              element={
                <Home
                  sideBarComponent={{
                    "Admin Dashboard": [
                      {
                        icon: "fas fa-file-invoice",
                        name: "admin user_list",
                        path: "/admin/user_list",
                        section: "Admin Dashboard",
                        sideMenuName: "User List",
                      },
                      {
                        icon: "fas fa-file-invoice",
                        name: "admin Menu_list",
                        path: "/admin/menu_list",
                        section: "Admin Dashboard",
                        sideMenuName: "Menu List",
                      },
                      // {
                      //   icon: "fas fa-file-invoice",
                      //   name: "admin Account_list",
                      //   path: "/admin/acount_list",
                      //   section: "Admin Dashboard",
                      //   sideMenuName: "Account ",
                      // },
                    ],
                    "API Hit": [
                      // {
                      //   icon: "fas fa-file-invoice",
                      //   name: "admin hit-dashboard",
                      //   path: "/admin/hit-dashboard",
                      //   section: "Hit Dashboard",
                      //   sideMenuName: "Dashboard ",
                      // },
                      // {
                      //   icon: "fas fa-file-invoice",
                      //   name: "admin hit-client",
                      //   path: "/admin/hit-client",
                      //   section: "Hit Dashboard",
                      //   sideMenuName: "Client",
                      // },
                      // {
                      //   icon: "fas fa-file-invoice",
                      //   name: "admin hit-services",
                      //   path: "/admin/hit-services",
                      //   section: "Hit Dashboard",
                      //   sideMenuName: "Services",
                      // },
                      // {
                      //   icon: "fas fa-file-invoice",
                      //   name: "admin hit-key",
                      //   path: "/admin/hit-key",
                      //   section: "Hit Dashboard",
                      //   sideMenuName: "Services Key",
                      // },
                      // {
                      //   icon: "fas fa-file-invoice",
                      //   name: "admin hit-deploymentserver",
                      //   path: "/admin/hit-deploymentserver",
                      //   section: "Hit Dashboard",
                      //   sideMenuName: "Deployment Server",
                      // },
                      {
                        icon: "fas fa-file-invoice",
                        name: "admin hit-hitoverview",
                        path: "/admin/hit-hitoverview",
                        section: "Hit Dashboard",
                        sideMenuName: "Overview",
                      },
                    ],
                    // "Client": [
                    //   {
                    //     icon: "fas fa-file-invoice",
                    //     name: "admin newClient",
                    //     path: "/admin/clientlist",
                    //     section: "Additions",
                    //     sideMenuName: "Clients",

                    //   }
                    // ],
                    "API Logs": [
                      {
                        icon: "fas fa-file-invoice",
                        name: "admin api-logs",
                        path: "/api-logs",
                        section: "API Logs",
                        sideMenuName: "Dashboard",

                      },
                      {
                        icon: "fas fa-file-invoice",
                        name: "admin service-logs",
                        path: "/service-logs",
                        section: "API Logs",
                        sideMenuName: "Dashboard",

                      },
                    ]
                  }}
                  section={"Admin Dashboard"}

                />
              }
            />
          )
        )
      )
    
  
    
}
  }

  return (
    <div>
      <Router>


        <Routes>
          <Route
            exact
            path="/"
            element={<Login />}
          />
          <Route
                    exact
                    path="/Register"
                    element={<Register />}
                  />
          {user_Roll == "Admin" &&
            ["/admin/user_list", "/admin/user-details", "/admin/menu_list", "/admin/acount_list",
              // "/admin/hit-dashboard",
              // "/admin/hit-client",
              "/admin/hit-services",
              //  "/admin/hit-key", 
              // "/admin/hit-deploymentserver",
              "/admin/hit-hitoverview", "/admin/clientlist", "/admin/clientdetails",
              "/api-logs","/service-logs"].map(
                (itm, index) => (
                  <Route
                    key={index}
                    exact
                    path={itm}
                    element={
                      <Home
                        sideBarComponent={{
                          "Admin Dashboard": [
                            {
                              icon: "fas fa-file-invoice",
                              name: "admin user_list",
                              path: "/admin/user_list",
                              section: "Admin Dashboard",
                              sideMenuName: "User List",
                            },
                            {
                              icon: "fas fa-file-invoice",
                              name: "admin Menu_list",
                              path: "/admin/menu_list",
                              section: "Admin Dashboard",
                              sideMenuName: "Menu List",
                            },
                            // {
                            //   icon: "fas fa-file-invoice",
                            //   name: "admin Account_list",
                            //   path: "/admin/acount_list",
                            //   section: "Admin Dashboard",
                            //   sideMenuName: "Account ",
                            // },
                            {
                              icon: "fas fa-file-invoice",
                              name: "admin client_admin_list",
                              path: "/admin/client_admin_list",
                              section: "Admin Dashboard",
                              sideMenuName: "Client Admin List",
                            },
                          ],
                          "API Hit": [
                            // {
                            //   icon: "fas fa-file-invoice",
                            //   name: "admin hit-dashboard",
                            //   path: "/admin/hit-dashboard",
                            //   section: "Hit Dashboard",
                            //   sideMenuName: "Dashboard ",
                            // },
                            // {
                            //   icon: "fas fa-file-invoice",
                            //   name: "admin hit-client",
                            //   path: "/admin/hit-client",
                            //   section: "Hit Dashboard",
                            //   sideMenuName: "Client",
                            // },
                            // {
                            //   icon: "fas fa-file-invoice",
                            //   name: "admin hit-services",
                            //   path: "/admin/hit-services",
                            //   section: "Hit Dashboard",
                            //   sideMenuName: "Services",
                            // },
                            // {
                            //   icon: "fas fa-file-invoice",
                            //   name: "admin hit-key",
                            //   path: "/admin/hit-key",
                            //   section: "Hit Dashboard",
                            //   sideMenuName: "Services Key",
                            // },
                            // {
                            //   icon: "fas fa-file-invoice",
                            //   name: "admin hit-deploymentserver",
                            //   path: "/admin/hit-deploymentserver",
                            //   section: "Hit Dashboard",
                            //   sideMenuName: "Deployment Server",
                            // },
                            {
                              icon: "fas fa-file-invoice",
                              name: "admin hit-hitoverview",
                              path: "/admin/hit-hitoverview",
                              section: "Hit Dashboard",
                              sideMenuName: "Overview",
                            },
                          ],
                          // "Client": [
                          //   {
                          //     icon: "fas fa-file-invoice",
                          //     name: "admin newClient",
                          //     path: "/admin/clientlist",
                          //     section: "Additions",
                          //     sideMenuName: "Clients",

                          //   }
                          // ],
                          "API Logs": [
                            {
                              icon: "fas fa-file-invoice",
                              name: "admin api-logs",
                              path: "/api-logs",
                              section: "API Logs",
                              sideMenuName: "Dashboard",

                            },
                            {
                              icon: "fas fa-file-invoice",
                              name: "admin service-logs",
                              path: "/service-logs",
                              section: "API Logs",
                              sideMenuName: "Dashboard",

                            }
                          ]
                        }}
                        section={"Admin Dashboard"}

                      />
                    }
                  />
                )
              )} 
                        <Route exact path="/npci_cheque_comparison" element={<Cheque_comparison />} />
                        {/* <Route exact path="/document_comparison" element={<DocumentComparison />} /> */}
              {getRoutes(user_Roll)}
          {/* {//console.log('current menu list', menuList)} */}
            {/* {//console.log('current route list', routeList)} */}
          {console.log('current filter route list', filterRouteData(routeList, menuList && menuList.map((i) => i.menuName)))}
          {console.log( "--------aaaa------->",combineAllRoutes(filterRouteData(routeList, menuList && menuList.map((i) => i.menuName))))}
            { combineAllRoutes(filterRouteData(routeList, menuList && menuList.map((i) => i.menuName))).length > 0 &&
            combineAllRoutes(filterRouteData(routeList, menuList && menuList.map((i) => i.menuName)))?.map(
              (item, index) => (
          <Route
            key={index}
            exact
            path={item.path}
            element={
              <Home
                selectedMenu={item.name}
                sideBarComponent={filterRouteData(routeList, menuList && menuList?.map((i) => i.menuName))}
                isdoubleSide={item.isdoubleSide}
                headerName={item.sideMenuName}
                documentSideKeys={item.documentSideKeys}
                section={item.section}
                fields={item.fields}
                discription={item?.discription}
                discriptionHead={item?.discriptionHead}
              />
            }
          />
          )
            )}
          <Route exact path="/dashboard" element={<Dashboard />} />
          <Route exact path="/landing" element={<Landingpage />} />
          <Route exact path="*" element={<Login />} />
          <Route exact path="/sign" element={<SignatureCrop />} />
          <Route exact path="/face" element={<FaceMatching />} />
          <Route exact path="/chatbot" element={<AiChatbot />} />

        </Routes>
      </Router>
    </div>
  )
}

export default RouterComponent
